// extracted by mini-css-extract-plugin
module.exports = {"label":"label__2XUDN","sub":"sub__8nao2"};